import { notification } from 'antd/lib'
import { useUserDetails } from 'Contexts/UserDetailsContext'
import useService from 'Hooks/use-service'
import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getExamDetailForCandidate } from 'Services/exams.service'

export const useExamDetail = () => {
    const userDetails = useUserDetails()
    const params = useParams()
    const navigate = useNavigate()
    const { data, isLoading, error, trigger } = useService(getExamDetailForCandidate)

    useEffect(() => {
        if (userDetails && params.examId) {
            trigger({
                userId: userDetails.userID,
                examId: params.examId,
            })
        }
    }, [params.examId, trigger, userDetails])

    useEffect(() => {
        if (error) {
            notification.error({
                message: (error as Error).message ?? 'Error in loading exam details',
                description:
                    'Please try again. If you still face the issue, reach out to the project owner',
                placement: 'bottomLeft',
            })
            navigate(`/`, { replace: true })
        }
    }, [error, navigate])

    return { data, isLoading, error }
}
